<script>
    import InfiniteLoading from "svelte-infinite-loading";
    import Submit from "./Submit.svelte";
    import Footer from "./components/Footer.svelte";
    import Post from "./Post.svelte";
    import { entitiesArray, entitiesPages, entitiesSplit } from "./stores";

    let arrayIndex = 0; // page number for infinite scroll/loading
	function infiniteHandler({ detail: { loaded, complete } }) {
		let entities = $entitiesArray;
		arrayIndex++;
		console.log("added array index", arrayIndex, "to infinte scroll array");
		if (arrayIndex < $entitiesPages) {
			entities = entities.concat($entitiesSplit[arrayIndex]);
			entitiesArray.set(entities);
			console.log($entitiesArray);
			loaded();
		} else {
			complete();
		}
	}
 </script>
 
 
 <div>
    {#each $entitiesArray as stim}
        <Post {stim}></Post>
    {/each}
    <InfiniteLoading on:infinite={infiniteHandler}>
        <!-- https://github.com/Skayo/svelte-infinite-loading/wiki/Slots -->
        <span slot="noMore"> <Submit /><Footer /></span>
        <span slot="noResults"> <Submit /><Footer /></span>
    </InfiniteLoading>
 </div>

